import { Injectable, OnDestroy } from '@angular/core';
import { generateClient } from '@aws-amplify/api';
import { Subscription, Subject, BehaviorSubject } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppSyncService implements OnDestroy{
  subscribeAppSync: Subscription;
  sessionId: string;
  wsOfflineStatus = false;
  recentExport: Subject<any> = new BehaviorSubject<any>(null);


  private client = generateClient({
    authMode: 'lambda',
    authToken: `Bearer ${localStorage.getItem('access_token')}`,
  });

  constructor() { 
    this.sessionId = uuidv4();
  }

  subscribeAppSyncServer(dealerId: string): Observable<any> {
    const channelName = `ASP_DIGICHK_${dealerId}`;
    const subscriptionQuery = `
      subscription Subscribe($name: String!, $sessionId: String!) {
        subscribe(name: $name, sessionId: $sessionId) {
          name
          data
        }
      }
    `;
    return new Observable(observer => {
      const subscription = (this.client.graphql<any>({
        query: subscriptionQuery,
        variables: {
          name: channelName,
          sessionId: this.sessionId,
        }
      }) as any).subscribe({
        next: (result: any) => {
          try {
            const raw = result?.data?.subscribe?.data;
            const parsed = JSON.parse(raw);
            observer.next(parsed);
          } catch (error) {
            console.error('Failed to parse subscription data:', error);
            observer.error(error);
          }
        },
        error: (err: any) => {
          console.error('Subscription error:', err);
          observer.error(err);
        },
      });
    
      return () => subscription.unsubscribe();
    });
  }

  mutationAddSubscribe(dealerId, userId) {
    const channelName = `ASP_DIGICHK_${dealerId}_${userId}`;
    this.addSubscription(channelName, this.sessionId);
  }

  async addSubscription(name: string, sessionId: string) {
    const mutation = `
      mutation AddSubscription($name: String!, $sessionId: String!) {
        addSubscription(name: $name, sessionId: $sessionId) {
          name
          sessionId
        }
      }
    `;
    const variables = {
      name,
      sessionId
    };

    try {
      const response = await this.client.graphql({
        query: mutation,
        variables
      }) as any;

      return response.data?.addSubscription;
    } catch (error) {
      console.error('GraphQL error:', error);
      throw error;
    }
  }

  ngOnDestroy() {
    if (this.subscribeAppSync) {
      this.subscribeAppSync.unsubscribe();
    }
  }

}